export default __webpack_public_path__ + "static/media/others4.b8e860f4.jpg";